<script setup>
import { ref } from 'vue';
import PageSliderCard from '@/components/cards/PageSliderCard.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '@/assets/styles/swiper-custom.scss';
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div class="pages-cards__slider">
    <Swiper
      :slides-per-view="'auto'"
      :space-between="16"
      :modules="[Navigation, Pagination]"
      :navigation="{
        prevEl: '.pages-cards__slider-navigation-prev',
        nextEl: '.pages-cards__slider-navigation-next',
      }"
      :pagination="{
        el: '.pages-cards__slider-pagination',
      }"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      @swiper="onSwiper"
      @lock="onLockToggle"
      @unlock="onLockToggle"
    >
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <PageSliderCard
          :url="item?.url"
          :title="item?.title"
          :image="item?.image"
          :description="item?.description"
          :background-color="backgroundColor"
        />
      </SwiperSlide>
    </Swiper>
    <div
      class="swiper-pagination swiper-pagination--onblack pages-cards__slider-pagination"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    ></div>
    <div
      class="swiper-navigation pages-cards__slider-navigation"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    >
      <Button
        type="button"
        rounded
        variant="outlined"
        class="pages-cards__slider-navigation-prev button-prev js-button-page-cards-prev"
      >
        <CIcon
          class="button-prev__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
      <Button
        type="button"
        rounded
        variant="outlined"
        class="pages-cards__slider-navigation-next button-next js-button-page-cards-next"
      >
        <CIcon
          class="button-next__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
.pages-cards__slider {
  .swiper {
    height: 100%;
    overflow: visible;
    width: 100%;
    @include media-breakpoint-up(md) {
      overflow: hidden;
    }
  }
  .swiper-slide {
    align-self: stretch;
    height: auto;
    max-width: calc(100vw - 48px);
    width: 312px;
    @include media-breakpoint-up(sm) {
      max-width: unset;
      width: 348px;
    }
    @include media-breakpoint-up(md) {
      width: 584px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(width, 584);
    }
  }
}
</style>
